import { firstValueFrom } from 'rxjs'
import { createAppAsyncThunk, StoreThunkDispatch } from 'store/state'
import { adaptAIConversations } from './adapter'
import { V1 } from './net'

export function fetchHashtagsSuggestions(text?: string, link?: string) {
  return (dispatch: StoreThunkDispatch) => {
    return dispatch(V1.getTags(text, link))
  }
}

export const generateCaption = createAppAsyncThunk(
  'composer/generateCaption',
  async (args: { prompt: string, conversationId?: string }, { dispatch, rejectWithValue }) => {
    try {
      const response = await firstValueFrom(dispatch(V1.generateCaption(args.prompt, args.conversationId)))
      return response
    } catch (error) {
      console.error('Error generating caption:', error)
      return rejectWithValue(error)
    }
  }
)

export const generateImage = createAppAsyncThunk(
  'composer/generateImage',
  async (args: { prompt: string, ratio: string, sessionId?: string }, { dispatch, rejectWithValue }) => {
    try {
      const response = await firstValueFrom(dispatch(V1.generateImage(args.prompt, args.ratio, args.sessionId)))
      return { image: response.images[0], sessionId: response.sessionId }
    } catch (error) {
      console.error('Error generating image:', error)
      return rejectWithValue(error)
    }
  }
)

export const fetchAIConversations = createAppAsyncThunk(
  'composer/fetchAIConversations',
  async (_: void, { dispatch, rejectWithValue }) => {
    try {
      const response = await firstValueFrom(dispatch(V1.getConversations()))
      if (response && response.error) {
        return rejectWithValue(response.error)
      }
      return adaptAIConversations(response)
    } catch (error) {
      console.error('Error fetching AI conversations:', error)
      return rejectWithValue(error)
    }
  }
)

export const deleteAIConversation = createAppAsyncThunk(
  'composer/deleteAIConversation',
  async (id: string, { dispatch, rejectWithValue }) => {
    try {
      await firstValueFrom(dispatch(V1.deleteConversation(id)))
      return id
    } catch (error) {
      console.error('Error deleting AI conversation:', error)
      return rejectWithValue(error)
    }
  }
)
